<h1 style="text-align: center">{{ data.name | uppercase }}</h1>

<form
  [formGroup]="areaForm"
  *ngIf="data.name == 'area'"
  (ngSubmit)="areaForm.valid ? save(areaForm.value) : errorMessage()"
>
  <!-- Responsable new preventive -->
  <combos
    [configuration]="combosConfigResponsible"
    [required]="true"
    [filter]="true"
    (changeOption)="ValueResponsable($event)"
  >
  </combos>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="name"
      matInput
      placeholder="Nombre"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="code"
      matInput
      placeholder="Código"
    />
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="description"
      matInput
      placeholder="Descripción"
    />
  </mat-form-field>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="areaForm.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

<form
  [formGroup]="itemForm"
  *ngIf="data.name == 'item'"
  (ngSubmit)="itemForm.valid ? save(itemForm.value) : errorMessage()"
>
  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="code"
      matInput
      placeholder="Código"
      required
    />
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="itemName"
      matInput
      placeholder="Nombre"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="number"
      formControlName="costItem"
      matInput
      placeholder="Costo Item"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="unitMeasurement"
      matInput
      placeholder="Unidad"
    />
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="description"
      matInput
      placeholder="Descripción"
    />
  </mat-form-field>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="itemForm.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

<form
  [formGroup]="jobTitleForm"
  *ngIf="data.name == 'cargo'"
  (ngSubmit)="jobTitleForm.valid ? save(jobTitleForm.value) : errorMessage()"
>
  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="name"
      matInput
      placeholder="Cargo"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="jobTitleForm.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

<form
  [formGroup]="equipmentTypeForm"
  *ngIf="data.name == 'tipo de equipo'"
  (ngSubmit)="
    equipmentTypeForm.valid ? save(equipmentTypeForm.value) : errorMessage()
  "
>
  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="name"
      matInput
      placeholder="Tipo de equipo"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="equipmentTypeForm.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

<form
  [formGroup]="countryForm"
  *ngIf="data.name == 'pais'"
  (ngSubmit)="countryForm.valid ? save(countryForm.value) : errorMessage()"
>
  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="country"
      matInput
      placeholder="Pais"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="countryForm.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

<form
  [formGroup]="regionForm"
  *ngIf="data.name == 'departamento'"
  (ngSubmit)="regionForm.valid ? save(regionForm.value) : errorMessage()"
>
  <mat-form-field>
    <mat-label>Pais</mat-label>
    <mat-select formControlName="countryId" required>
      <mat-option *ngFor="let pais of comboCountry" value="{{ pais.id }}">
        {{ pais.pais }}
      </mat-option>
    </mat-select>
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="region"
      matInput
      placeholder="departamento"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="regionForm.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

<form
  [formGroup]="cityForm"
  *ngIf="data.name == 'ciudad'"
  (ngSubmit)="cityForm.valid ? save(cityForm.value) : errorMessage()"
>
  <mat-form-field>
    <mat-label>departamento</mat-label>
    <mat-select formControlName="regionId" required>
      <mat-option
        *ngFor="let departamento of comboRegions"
        value="{{ departamento.id }}"
      >
        {{ departamento.departamento }}
      </mat-option>
    </mat-select>
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="city"
      matInput
      placeholder="ciudad"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="cityForm.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

<form
  [formGroup]="epsForm"
  *ngIf="data.name == 'eps'"
  (ngSubmit)="epsForm.valid ? save(epsForm.value) : errorMessage()"
>
  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="name"
      matInput
      placeholder="EPS"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="contactNumber"
      matInput
      placeholder="Contacto"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="epsForm.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

<form
  [formGroup]="arlForm"
  *ngIf="data.name == 'arl'"
  (ngSubmit)="arlForm.valid ? save(arlForm.value) : errorMessage()"
>
  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="name"
      matInput
      placeholder="ARL"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="contact"
      matInput
      placeholder="Contacto"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="arlForm.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

<form
  [formGroup]="controlPointerForm"
  *ngIf="data.name == 'punto de control'"
  (ngSubmit)="
    controlPointerForm.valid ? save(controlPointerForm.value) : errorMessage()
  "
>
  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="name"
      matInput
      placeholder="Nombre"
      required
    />
    <mat-error>Campo requerido</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      autocomplete="off"
      type="text"
      formControlName="description"
      matInput
      placeholder="Comentario"
    />
  </mat-form-field>

  <div *ngIf="!data.body.complete" class="containerPhotos">
      <file-input
        [params]="fileInput"
        (fileSave)="fileSave($event)"
      ></file-input>
  </div>

  <div class="containerPhotos" *ngIf="imageSrc && data.body.complete">
    <img class="mat-elevation-z8" src="{{imageSrc}}" [ngStyle]="sizePicture">
  </div>
  
  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="controlPointerForm.invalid"
    mat-raised-button
    type="submit"
  >
    {{saveButtonNameCheckpoint}}
  </button>
</form>

<form
  *ngIf="data.name == 'comentario'"
  [formGroup]="commentForm"
  (ngSubmit)="commentForm.valid ? save(commentForm.value) : errorMessage()"
>
  <combos
    [configuration]="combosConfigCommentsTypes"
    [required]="true"
    [filter]="true"
    [control]="commentForm.get('commentTypeId')"
    (changeOptionDataComplete)="onChangeCommentType($event)"
    (returnDataCombo)="commentTypeData($event)"
  >
  </combos>

  <mat-form-field>
    <textarea
      autocomplete="off"
      formControlName="comment"
      matInput
      #descripcion
      rows="3"
      maxlength="10000"
      placeholder="Comentario"
      class="min-rows-2"
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="15"
    ></textarea>
    <mat-hint>{{ descripcion.value.length }}/10000</mat-hint>
  </mat-form-field>

  <file-input
    *ngIf="commentType && commentType.requiredFile"
    class="w-100 mt-3"
    [params]="fileInputPdfOrImg"
    (fileSave)="fileSave($event)"
  ></file-input>

  <button
    color="warn"
    class="button-save mat-elevation-z5"
    [disabled]="commentForm?.invalid"
    mat-raised-button
    type="submit"
  >
    Guardar
  </button>
</form>

